var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgColumnsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 12,
    viewBox: "0 -2 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-0.00390625 10.168V1.83464C-0.00390625 1.3763 0.159288 0.983941 0.485677 0.657552C0.812066 0.331163 1.20443 0.167969 1.66276 0.167969H13.3086C13.7669 0.167969 14.1593 0.331163 14.4857 0.657552C14.8121 0.983941 14.9753 1.3763 14.9753 1.83464V10.168C14.9753 10.6263 14.8121 11.0187 14.4857 11.3451C14.1593 11.6714 13.7669 11.8346 13.3086 11.8346H1.66276C1.20443 11.8346 0.812066 11.6714 0.485677 11.3451C0.159288 11.0187 -0.00390625 10.6263 -0.00390625 10.168ZM1.64193 10.168H4.41276V1.83464H1.64193V10.168ZM6.07943 10.168H8.85026V1.83464H6.07943V10.168ZM10.5169 10.168H13.2878V1.83464H10.5169V10.168Z",
    fill: "#556069"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColumnsIcon);
export default __webpack_public_path__ + "static/media/columnsIcon.a0a917b9900fe3fa0631bba6d32523b0.svg";
export { ForwardRef as ReactComponent };